// DS: i3.12
import React from 'react';
import IconWrap from '../../IconWrap';
const GiveBadge = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.291 1.486A1 1 0 0012.434 1H3.566a1 1 0 00-.857.486L.378 5.37a1 1 0 00.11 1.179l6.765 7.61.083.083a1 1 0 001.411-.083l.356-.4c.373-.42.355-1.059-.043-1.457l-.356-.354a.499.499 0 00-.704.041l-5.53-6.22 1.662-2.77h7.735l1.662 2.77-.072.093a.828.828 0 00.105 1.044l.196.193a.945.945 0 001.334-.078l.42-.472a1 1 0 00.11-1.179l-2.33-3.885zM13 8a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 102 0v-1h1a1 1 0 000-2h-1V8z",
        clipRule: "evenodd"
    })));
};
GiveBadge.displayName = 'GiveBadge';
export default GiveBadge;
